// extracted by mini-css-extract-plugin
export default {"componentWrapper":"WiseHeaderTopBar_componentWrapper__QnPUV","language":"WiseHeaderTopBar_language__QMDms","authButton":"WiseHeaderTopBar_authButton__yEN0l"};